module.exports = __webpack_public_path__ + "media/icons/bag-circle-b26528ed.svg";